<template>
  <div class="view">
    <v-card width="350">
      <div
        class="header navy darken-2 secondary--text pb-10 d-flex flex-column align-center"
      >
        <img class="logo" :src="firebase_host + '/static/img/logo.png'" />
      </div>

      <v-progress-circular
        indeterminate
        class="ma-10"
        v-if="astaInfo === false"
      ></v-progress-circular>

      <NotFound
        v-else-if="astaInfo === null"
        text="Asta non trovata"
      ></NotFound>

      <div v-else>
        <!-- premium -->
        <div v-if="astaInfo.premium" class="pa-4">
          <v-icon color="secondary" class="big-icon">check</v-icon>
          <h2 class="secondary--text font-hemi-head">
            Asta sbloccata con successo
          </h2>
        </div>

        <!-- non premium con testo di errore-->

        <div v-else-if="!astaInfo.premium && paymentError" class="pa-4">
          <v-icon color="error" class="big-icon">cancel</v-icon>
          <h2 class="error--text font-hemi-head">
            {{ paymentError }}
          </h2>
        </div>

        <div v-else-if="!astaInfo.premium && paymentWarning" class="pa-4">
          <v-icon color="warning" class="big-icon">warning</v-icon>
          <h2 class="warning--text font-hemi-head">
            {{ paymentWarning }}
          </h2>
        </div>

        <!-- non premium senza testo di errore-->
        <div v-else class="px-8 py-5 d-flex flex-column align-center">
          <h1 class="font-hemi-head">Sblocca</h1>
          <h2 class="font-hemi-head">
            <b>{{ astaInfo.name }}</b>
          </h2>
          <small
            >ASTA DA (MASSIMO)
            <b>{{ astaInfo.lega.maxSquadre }}</b> SQUADRE</small
          >
          <div class="prezzo-asta font-hemi-head">
            {{ getPrezzoAsta(astaInfo.lega.maxSquadre) }} €
          </div>
          <form :action="endpoint" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input type="hidden" name="lc" value="IT" />
            <input type="hidden" name="custom" :value="customJson" />
            <input type="hidden" name="hosted_button_id" :value="buttonId" />
            <v-btn
              large
              depressed
              type="submit"
              value="Paga con Payal"
              name="submit"
              id="paypal-btn"
              title="PayPal è il metodo rapido e sicuro per pagare e farsi pagare online."
              @click="loader = true"
            >
              <v-icon left color="#003087">fa-paypal</v-icon>
              <span class="pay">Pay</span>
              <span class="pal">pal</span>
              <v-progress-circular
                class="loader"
                indeterminate
                size="16"
                color="#ffc43a"
                v-if="loader"
              ></v-progress-circular>
            </v-btn>
            <div class="cc d-flex justify-center mt-2">
              <img :src="firebase_host + '/static/img/cc-1.png'" />
              <img :src="firebase_host + '/static/img/cc-2.png'" />
              <img :src="firebase_host + '/static/img/cc-3.png'" />
              <img :src="firebase_host + '/static/img/cc-4.png'" />
            </div>
            <img class="no-border" :src="src" width="1" height="1" />
          </form>
          <v-btn
            small
            depressed
            text
            class="mt-2"
            @click="openDialogCopyUrl"
            style="text-transform: none"
            >Non hai Paypal?</v-btn
          >
        </div>
        <div class="d-flex justify-space-between">
          <v-btn
            v-if="Config.STANDALONE"
            small
            depressed
            text
            class="ma-4"
            @click="gotoHome"
            style="text-transform: none"
            >Home</v-btn
          >
          <div v-else></div>
          <v-btn
            small
            depressed
            text
            class="ma-4"
            @click="gotoAsta"
            style="text-transform: none"
            >Vai all'Asta</v-btn
          >
        </div>
        <dialog-copy-url-pagamento
          :asta_id_="astaInfo.id"
        ></dialog-copy-url-pagamento>
      </div>
    </v-card>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import db from "../../js/db";
import Config from "../../../config-app/config";
import DialogCopyUrlPagamento from "../dialogs/DialogCopyUrlPagamento";
import NotFound from "./NotFound";

export default {
  name: "pagamento",
  mixins: [mixins, toast],
  components: { DialogCopyUrlPagamento, NotFound },
  data() {
    return {
      astaInfo: false,
      firebase_host: Config.FIREBASE_HOST,
      customJson: null,
      buttonId: null,
      src: "https://" + Config.PAYPAL_HOST + "/en_US/i/scr/pixel.gif",
      endpoint: "https://" + Config.PAYPAL_HOST + "/cgi-bin/webscr",
      loader: false,
      url: null,
      paymentError: null,
      paymentWarning: null,
    };
  },

  methods: {
    gotoHome() {
      this.$router.push({
        path: "/",
      });
    },
    gotoAsta() {
      this.$router.push({ name: "asta", params: { id: this.astaInfo.id } });
    },
    openDialogCopyUrl() {
      db.emit("dialogCopyUrlPagamentoEmitted");
    },
    getCustomJson() {
      let custom = null;
      if (Config.STANDALONE) {
        custom = {
          hook: "standalone",
          ID_Asta: this.astaInfo.id,
          uid: this.user_uid,
          // return_url: this.url,
        };
      } else {
        custom = {
          hook: "asta_live",
          ID_Asta: this.astaInfo.id,
          uid: this.fp_uid(this.user_uid),
          torneo_id: Config.TORNEO_ID,
          // return_url: this.url,
        };
      }
      return JSON.stringify(custom);
    },
  },

  async mounted() {
    console.log("Pagamento mounted.");
    const asta_id = this.$route.params.asta_id;
    this.astaInfo = await db.getAstaInfo(asta_id);
    if (this.astaInfo) {
      // this.url = this.getUrlPagamento(asta_id)
      this.customJson = this.getCustomJson();
      this.buttonId = this.getPaypalButtonId(this.astaInfo.lega.maxSquadre);
      this.paymentError = this.$route.query.paymentError;
      this.paymentWarning = this.$route.query.paymentWarning;
    }
  },

  destroyed() {
    console.log("Pagamento destroyed.");
  },
};
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100%;

  .header {
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 115%;
      height: 35px;
      background-color: white;
      transform: skewY(-6deg);
    }
  }

  .logo {
    width: 102px;
    margin-top: 30px;
  }

  #paypal-btn {
    background: #ffc43a;
    font-weight: bold;
    font-family: verdana;
    font-style: italic;
    position: relative;
    .pay {
      color: #003087;
    }
    .pal {
      color: #009cde;
    }
    .loader {
      position: absolute;
      right: -45px;
    }
  }

  .prezzo-asta {
    font-size: 45px;
    margin-bottom: 0px;
    font-weight: bold;
  }

  .big-icon {
    animation: vanishIn 0.5s;
    font-size: 100px;
  }
  .cc img {
    width: 30px;
    margin: 0 2px;
  }
}
</style>

